<template>
  <div>
    <img src="static/assets/images/135.png" style="width: 100%;height: 600px;"/>
    <!-- Start Sample Area -->
<!--    <section class="sample-text-area">-->
<!--      <div class="container">-->
<!--        <h3 class="text-heading title_color">Text Sample</h3>-->
<!--        <p class="sample-text">-->
<!--          Every avid independent filmmaker has <b>Bold</b> about making that <i>Italic</i> interest documentary, or short film to show off their creative prowess. Many have great ideas and want to “wow” the<sup>Superscript</sup> scene, or video renters with their big project.  But once you have the<sub>Subscript</sub> “in the can” (no easy feat), how do you move from a <del>Strike</del> through of master DVDs with the <u>“Underline”</u> marked hand-written title inside a secondhand CD case, to a pile of cardboard boxes full of shiny new, retail-ready DVDs, with UPC barcodes and polywrap sitting on your doorstep?  You need to create eye-popping artwork and have your project replicated. Using a reputable full service DVD Replication company like PacificDisc, Inc. to partner with is certainly a helpful option to ensure a professional end result, but to help with your DVD replication project, here are 4 easy steps to follow for good DVD replication results:-->

<!--        </p>-->
<!--      </div>-->
<!--    </section>-->
    <!-- End Sample Area -->
    <!-- Start Button -->
<!--    <section class="button-area">-->
<!--      <div class="container border-top-generic">-->
<!--        <h3 class="text-heading title_color">Sample Buttons</h3>-->
<!--        <div class="button-group-area">-->
<!--          <a href="#" class="genric-btn default">Default</a>-->
<!--          <a href="#" class="genric-btn primary">Primary</a>-->
<!--          <a href="#" class="genric-btn success">Success</a>-->
<!--          <a href="#" class="genric-btn info">Info</a>-->
<!--          <a href="#" class="genric-btn warning">Warning</a>-->
<!--          <a href="#" class="genric-btn danger">Danger</a>-->
<!--          <a href="#" class="genric-btn link">Link</a>-->
<!--          <a href="#" class="genric-btn disable">Disable</a>-->
<!--        </div>-->
<!--        <div class="button-group-area mt-10">-->
<!--          <a href="#" class="genric-btn default-border">Default</a>-->
<!--          <a href="#" class="genric-btn primary-border">Primary</a>-->
<!--          <a href="#" class="genric-btn success-border">Success</a>-->
<!--          <a href="#" class="genric-btn info-border">Info</a>-->
<!--          <a href="#" class="genric-btn warning-border">Warning</a>-->
<!--          <a href="#" class="genric-btn danger-border">Danger</a>-->
<!--          <a href="#" class="genric-btn link-border">Link</a>-->
<!--          <a href="#" class="genric-btn disable">Disable</a>-->
<!--        </div>-->
<!--        <div class="button-group-area mt-40">-->
<!--          <a href="#" class="genric-btn default radius">Default</a>-->
<!--          <a href="#" class="genric-btn primary radius">Primary</a>-->
<!--          <a href="#" class="genric-btn success radius">Success</a>-->
<!--          <a href="#" class="genric-btn info radius">Info</a>-->
<!--          <a href="#" class="genric-btn warning radius">Warning</a>-->
<!--          <a href="#" class="genric-btn danger radius">Danger</a>-->
<!--          <a href="#" class="genric-btn link radius">Link</a>-->
<!--          <a href="#" class="genric-btn disable radius">Disable</a>-->
<!--        </div>-->
<!--        <div class="button-group-area mt-10">-->
<!--          <a href="#" class="genric-btn default-border radius">Default</a>-->
<!--          <a href="#" class="genric-btn primary-border radius">Primary</a>-->
<!--          <a href="#" class="genric-btn success-border radius">Success</a>-->
<!--          <a href="#" class="genric-btn info-border radius">Info</a>-->
<!--          <a href="#" class="genric-btn warning-border radius">Warning</a>-->
<!--          <a href="#" class="genric-btn danger-border radius">Danger</a>-->
<!--          <a href="#" class="genric-btn link-border radius">Link</a>-->
<!--          <a href="#" class="genric-btn disable radius">Disable</a>-->
<!--        </div>-->
<!--        <div class="button-group-area mt-40">-->
<!--          <a href="#" class="genric-btn default circle">Default</a>-->
<!--          <a href="#" class="genric-btn primary circle">Primary</a>-->
<!--          <a href="#" class="genric-btn success circle">Success</a>-->
<!--          <a href="#" class="genric-btn info circle">Info</a>-->
<!--          <a href="#" class="genric-btn warning circle">Warning</a>-->
<!--          <a href="#" class="genric-btn danger circle">Danger</a>-->
<!--          <a href="#" class="genric-btn link circle">Link</a>-->
<!--          <a href="#" class="genric-btn disable circle">Disable</a>-->
<!--        </div>-->
<!--        <div class="button-group-area mt-10">-->
<!--          <a href="#" class="genric-btn default-border circle">Default</a>-->
<!--          <a href="#" class="genric-btn primary-border circle">Primary</a>-->
<!--          <a href="#" class="genric-btn success-border circle">Success</a>-->
<!--          <a href="#" class="genric-btn info-border circle">Info</a>-->
<!--          <a href="#" class="genric-btn warning-border circle">Warning</a>-->
<!--          <a href="#" class="genric-btn danger-border circle">Danger</a>-->
<!--          <a href="#" class="genric-btn link-border circle">Link</a>-->
<!--          <a href="#" class="genric-btn disable circle">Disable</a>-->
<!--        </div>-->
<!--        <div class="button-group-area mt-40">-->
<!--          <a href="#" class="genric-btn default circle arrow">Default<span class="lnr lnr-arrow-right"></span></a>-->
<!--          <a href="#" class="genric-btn primary circle arrow">Primary<span class="lnr lnr-arrow-right"></span></a>-->
<!--          <a href="#" class="genric-btn success circle arrow">Success<span class="lnr lnr-arrow-right"></span></a>-->
<!--          <a href="#" class="genric-btn info circle arrow">Info<span class="lnr lnr-arrow-right"></span></a>-->
<!--          <a href="#" class="genric-btn warning circle arrow">Warning<span class="lnr lnr-arrow-right"></span></a>-->
<!--          <a href="#" class="genric-btn danger circle arrow">Danger<span class="lnr lnr-arrow-right"></span></a>-->
<!--        </div>-->
<!--        <div class="button-group-area mt-10">-->
<!--          <a href="#" class="genric-btn default-border circle arrow">Default<span class="lnr lnr-arrow-right"></span></a>-->
<!--          <a href="#" class="genric-btn primary-border circle arrow">Primary<span class="lnr lnr-arrow-right"></span></a>-->
<!--          <a href="#" class="genric-btn success-border circle arrow">Success<span class="lnr lnr-arrow-right"></span></a>-->
<!--          <a href="#" class="genric-btn info-border circle arrow">Info<span class="lnr lnr-arrow-right"></span></a>-->
<!--          <a href="#" class="genric-btn warning-border circle arrow">Warning<span class="lnr lnr-arrow-right"></span></a>-->
<!--          <a href="#" class="genric-btn danger-border circle arrow">Danger<span class="lnr lnr-arrow-right"></span></a>-->
<!--        </div>-->
<!--        <div class="button-group-area mt-40">-->
<!--          <a href="#" class="genric-btn primary e-large">Extra Large</a>-->
<!--          <a href="#" class="genric-btn success large">Large</a>-->
<!--          <a href="#" class="genric-btn primary">Default</a>-->
<!--          <a href="#" class="genric-btn success medium">Medium</a>-->
<!--          <a href="#" class="genric-btn primary small">Small</a>-->
<!--        </div>-->
<!--        <div class="button-group-area mt-10">-->
<!--          <a href="#" class="genric-btn primary-border e-large">Extra Large</a>-->
<!--          <a href="#" class="genric-btn success-border large">Large</a>-->
<!--          <a href="#" class="genric-btn primary-border">Default</a>-->
<!--          <a href="#" class="genric-btn success-border medium">Medium</a>-->
<!--          <a href="#" class="genric-btn primary-border small">Small</a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
    <!-- End Button -->
    <!-- Start Align Area -->
    <div class="whole-wrap">
      <div class="container">
        <div class="section-top-border">
          <h3 class="mb-30 title_color">关于我们</h3>
          <div class="row">
            <div class="col-md-4">
              <img src="static/assets/images/150.jpg" alt="" class="img-fluid" style="width: 350px">
            </div>
            <div class="col-md-8 mt-sm-20 left-align-p" style="margin-top: 40px">
              <p>北京点金企服科技有限公司涉及互联网财税、商业保理、企业
                用工服务等多项领域，为大中小企业提供劳动服务外包、
                税务筹划、收入结算、人工智能报税等服务的共享经济综
                合服务平台。</p>
              <p>致力于打造完整的灵活用工的专属供应链，打破传统财税结算模式，综合运用大数据、云计算、移动互联网等技术，解民企之急，解财税之惑。用科技深度赋能“人、财、税”的企业级服务，成为行业高效运行的助推剂。
              </p>
            </div>
          </div>
        </div>
<!--        <div class="section-top-border text-right">-->
<!--          <h3 class="mb-30 title_color">Right Aligned</h3>-->
<!--          <div class="row">-->
<!--            <div class="col-md-9">-->
<!--              <p class="text-right">Over time, even the most sophisticated, memory packed computer can begin to run slow if we don’t do something to prevent it. The reason why has less to do with how computers are made and how they age and more to do with the way we use them. You see, all of the daily tasks that we do on our PC from running programs to downloading and deleting software can make our computer sluggish. To keep this from happening, you need to understand the reasons why your PC is getting slower and do something to keep your PC running at its best. You can do this through regular maintenance and PC performance optimization programs</p>-->
<!--              <p class="text-right">Before we discuss all of the things that could be affecting your PC’s performance, let’s talk a little about what symptoms</p>-->
<!--            </div>-->
<!--            <div class="col-md-3">-->
<!--              <img src="static/assets/images/elements/d.jpg" alt="" class="img-fluid">-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="section-top-border">
          <h3 class="mb-30 title_color">企业文化</h3>
          <div class="row">
            <div class="col-md-4">
              <div class="single-defination">
                <h4 class="mb-20">服务理念</h4>
                <p>耐心、专心</p>
                <p>倾听、互助、感恩</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="single-defination">
                <h4 class="mb-20">核心价值观</h4>
                <p>诚信负责、专业进取</p>
                <p>成就笔户、完善自我</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="single-defination">
                <h4 class="mb-20">战略方向</h4>
                <p>以顾客为中心、以服务为根本</p>
                <p>以市场为导向、以品牌为核心</p>
              </div>
            </div>
          </div>
        </div>

<!--        <div class="section-top-border">-->
<!--          <h3 class="mb-30 title_color">联系我们</h3>-->
<!--          <div class="row">-->
<!--            <div class="col-md-4">-->
<!--              <img src="static/assets/images/elements/d.jpg" alt="" class="img-fluid" style="width: 350px">-->
<!--            </div>-->
<!--            <div class="col-md-8 mt-sm-20 left-align-p" style="margin-top: 60px">-->
<!--              <p>联系人：</p>-->
<!--              <p>联系电话：</p>-->
<!--              <p>联系地址：北京市昌平区西三旗街道新龙大厦B座725</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->


      </div>
    </div>
    <!-- End Align Area -->
  </div>
</template>

<script>
  export default {
    mounted () {
      // 跳转后返回页面顶部
      window.scrollTo(0, 0)
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/Elements.vue